import { render, staticRenderFns } from "./m-block-receipt-sale-discount.vue?vue&type=template&id=feb86bf0&scoped=true&lang=pug&"
import script from "./m-block-receipt-sale-discount.vue?vue&type=script&lang=js&"
export * from "./m-block-receipt-sale-discount.vue?vue&type=script&lang=js&"
import style0 from "./m-block-receipt-sale-discount.vue?vue&type=style&index=0&id=feb86bf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb86bf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
